import React from "react";
import styles from "./calenderview.module.scss";
// import meetnow from "../../../../styles/images/meetnow.svg";
// import joinnow from "../../../../styles/images/joinnow.svg";
// import eventsvg from "../../../../styles/images/eventsvg.svg";
import CalenderTimeline from "../calenderTimeline";
import CalederTopSection from "../calenderTop";
import { getMeetingId } from "../../../../base/meetingService/apiService";
import SmartEpisodesScreen from "../smartepisode";
export default function CalederScreen() {

  return (
    <>
    
      <div className={styles.calenderScreen}>
        <p className={styles.calenderTitle}>Your personal meeting ID <span className={styles.calDot}></span>
          <span className={styles.meetingID}>{getMeetingId()}</span>
        </p>
        <div className={styles.calenderBox}>
          <CalederTopSection />
          <CalenderTimeline />
        </div>
      </div>
    </>
  );
};

